define('app/sds/service/attributes/sds-service-attributes-service',["service!selcomm", "$q"], function (SelcommWS, $q) {
	var sourcePrototype = {
		update: function update(attribute) {
			return SelcommWS.put("Service", "ServiceAttributeUpdate", {
				ServiceAttribute: attribute
			});
		},
		displayTextExpr: "$attribute.AttributeTemplate.Description",
		selectValuesExpr: "$attribute.AttributeTemplate.PossibleValues",
		stringTypeExpr: "$attribute.AttributeTemplate.StringTypeCode",
		valueExpr: "$attribute.Value"
	};
	return function sdsServiceAttributes(serviceReference) {
		var source = Object.create(sourcePrototype);
		return SelcommWS.post("Service", "ServiceAttributeList", {
			Service: { ServiceId: serviceReference }
		}).then(function (serviceAttributeList) {
			source.items = (serviceAttributeList = (serviceAttributeList && serviceAttributeList.Items || serviceAttributeList));
			return $q.all(angular.map(serviceAttributeList, function (serviceAttribute) {
				return SelcommWS.get("Validation", "StringTypePossibleValues", {
					StringTypeCode: serviceAttribute.AttributeTemplate.StringTypeCode
				}).then(function SuccessResult(values) {
					var valFuzzy, fuzzyValueFix;
					if (values) {
						serviceAttribute.AttributeTemplate.PossibleValues = values;
						// Fix the case where whitespace padding causes drop-downs to not select the value.
						if (serviceAttribute.Value && values.indexOf(serviceAttribute) < 0) {
							valFuzzy = angular.isString(serviceAttribute.Value) ? serviceAttribute.Value.trim() : serviceAttribute.Value;
							fuzzyValueFix = angular.filter(values, function (keyValuePair) {
								var keyFuzzy = angular.isString(keyValuePair.Key) ? keyValuePair.Key.trim() : keyValuePair.Key;
								return keyFuzzy == valFuzzy;
							});
							if (fuzzyValueFix.length === 1) {
								serviceAttribute.Value = fuzzyValueFix[0].Key;
							}
						}
						serviceAttribute.type = "select";
					}
					else {
						serviceAttribute.type = typeof serviceAttribute.Value;
					}
				});
			}));
		}).then(function () {
			return source;
		});
	};
});
